import queryString from 'query-string'
import { get } from 'lodash'

const PUT_BLOB = 'fo-dofe/blob/PUT_BLOB'
const PUT_BLOB_SUCCESS = 'fo-dofe/blob/PUT_BLOB_SUCCESS'
const PUT_BLOB_FAIL = 'fo-dofe/blob/PUT_BLOB_FAIL'

const initialState = {
  loaded: false,
  data: null
}

export default function blob(state = initialState, action = {}) {
  switch (action.type) {
    case PUT_BLOB:
      return {
        ...state,
        loading: true
      }

    case PUT_BLOB_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
      }

    case PUT_BLOB_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }

    default:
      return state
  }
}

export function putBlob(data, authorizationCode = null, additionalQueryParams = {}) {
  const assessorRegistrationId = get(additionalQueryParams, 'assessorRegistrationId')

  if (authorizationCode) {
    return {
      types: [PUT_BLOB, PUT_BLOB_SUCCESS, PUT_BLOB_FAIL],
      promise: client => client.post('api/blobs?' + queryString.stringify({ authorizationCode, assessorRegistrationId } ), {
        formData: true,
        data
      })
    }
  }
    return {
      types: [PUT_BLOB, PUT_BLOB_SUCCESS, PUT_BLOB_FAIL],
      promise: client => client.post('api/blobs', {
        formData: true,
        data
      })
    }
}

